"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProxyController = void 0;
var base_request_1 = require("../../requests/base-request");
var ProxyController = /** @class */ (function () {
    function ProxyController() {
    }
    // adds callback for each response (possibility for logging and metrics)
    ProxyController.prototype.setResponseTrackCallback = function (callbackParams) {
        try {
            base_request_1.BaseRequest.responseTrackCallbacks.push(callbackParams);
        }
        catch (error) {
            console.error('setResponseTrackCallback gets an error', error);
        }
    };
    // remove one of responseTrackCallbacks
    ProxyController.prototype.deleteResponseTrackCallback = function (callbackName) {
        base_request_1.BaseRequest.responseTrackCallbacks = base_request_1.BaseRequest.responseTrackCallbacks.filter(function (responseTrackCallback) { return responseTrackCallback.name !== callbackName; });
    };
    // adds params to all requests
    ProxyController.prototype.setPersistentOptions = function (callbackParams) {
        try {
            base_request_1.BaseRequest.persistentOptionsGetters.push(callbackParams);
        }
        catch (error) {
            console.error('setPersistentOptions gets an error', error);
        }
    };
    // remove one of setPersistentOptions
    ProxyController.prototype.deletePersistentOptions = function (callbackName) {
        try {
            base_request_1.BaseRequest.persistentOptionsGetters = base_request_1.BaseRequest.persistentOptionsGetters.filter(function (responseTrackCallback) { return responseTrackCallback.name !== callbackName; });
        }
        catch (error) {
            console.error('setPersistentOptions gets an error', error);
        }
    };
    return ProxyController;
}());
exports.ProxyController = ProxyController;
